const Profile = () => {
    return ( 
        <div className="profile-container">
            <p>Welcome Peter</p>
        </div>
     );
}
 
export default Profile;